import React, {Component} from "react";
import AccordionItem from "./AccordionItem";
import './Accordion.css';
import {addSearchChip} from "../../actions/searchActions";
import connect from "react-redux/lib/connect/connect";

class Accordion extends Component{
    constructor(props) {
        super(props);
        this.state = {
            clicked: '0',
            searchTerms: []
        };
    }

    getSearchOptions = (term) => {
        let so = this.props.searchObject.filter(o => o.title === term);
        if (typeof so[0] !== 'undefined' && typeof so[0].options !== 'undefined') {
            return so[0].options;
        }
        return [];
    }
    handleToggle = (index) => {
        if (this.state.clicked === index) {
            return this.setState({clicked: '0'});
        }
        this.setState({
            clicked: index
        });
    };
    onSelect = (value) => {
        this.props.dispatch(addSearchChip(value));
        this.props.closeModal(false, 'search');
    }


    render(){
        let items = this.props;
        return (
            <ul className="accordion">
                {items.data.map((it, index) => (
                    <AccordionItem
                        key={index}
                        title={it.title}
                        data={it.options}
                        onToggle={() => this.handleToggle(index)}
                        active={this.state.clicked === index}
                        onSelect={this.onSelect}
                    />
                ))}
            </ul>
        );
    }
};
export default connect(null)(Accordion);